import React, { useEffect } from "react";
import LabelValueRow from "../../LabelValueRow";
import { TextField } from "@mui/material";
import { InputAdornment } from "@mui/material";
import queryString from "query-string";

// CASSA PRIVATIZZATA
const CassaPrivatizzataWidget = ({
  redditoPrevidenziale,
  setContributiTotali,
  contributiTotali,
  isFullTime,
  cassaCoeff,
  setCassaCoeff,
}) => {
  const location = window.location;
  const urlParameters = queryString.parse(location.search);

  useEffect(() => {
    if (urlParameters.aliquotaCassa !== undefined) {
      setCassaCoeff(urlParameters.aliquotaCassa);
    }
  }, [urlParameters.aliquotaCassa, setCassaCoeff]);

  useEffect(() => {
    setContributiTotali(
      cassaCoeff !== 0 ? redditoPrevidenziale * (cassaCoeff / 100) : 0
    );
  }, [redditoPrevidenziale, cassaCoeff, setContributiTotali]);

  const handleCassaChange = (event) => {
    setCassaCoeff(event.target.value !== "" ? event.target.value : 0);
  };
  return (
    <div>
      {isFullTime === "1" && (
        <div className="flex flex-row justify-between items-center bg-gray-100 px-4 mb-4 pb-2 pt-2 dark:bg-gray-600">
          <div className="flex flex-col text-left">
            <span className="text-gray-400">
              Puoi ridurre l'aliquota della tua cassa privatizzata
            </span>
            <div className="text-sm leading-[1.2] dark:text-gray-400">
              Alcune casse previdenziali consentono la riduzione dell'aliquota
              per coloro i quali hanno già un impiego di lavoro dipendente
              full-time.
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-row justify-between items-center py-1 text-md">
        <span className="text-gray-400">Cassa previdenziale</span>
        <TextField
          variant="standard"
          style={{ width: "100px" }}
          value={String(cassaCoeff)}
          size="small"
          focused
          type="number"
          id="cassa_previdenziale"
          name="cassa"
          label="Aliquota cassa"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <p className="dark:text-white">%</p>
              </InputAdornment>
            ),
            inputMode: "numeric",
            pattern: "[0-9]*",
            classes: {
              root: " dark:bg-gray-800 dark:text-white px-1",
              focused: "",
            },
          }}
          placeholder={String(cassaCoeff)}
          InputLabelProps={{
            style: { color: "orange" },
          }}
          onChange={(e) => handleCassaChange(e)}
          onInput={(e) => {
            e.target.value = Math.max(0, parseInt(e.target.value))
              .toString()
              .slice(0, 2);
          }}
        />
      </div>
      <LabelValueRow
        label={"Contributi totali"}
        value={contributiTotali}
        important={true}
      />
    </div>
  );
};

export default CassaPrivatizzataWidget;
